<template>
  <div :class="(mask) ? 'loading_bg' : 'no_bg'">
    <div class="loading_content" :class="{white: isWhite}" v-if="isWhite">
      <div class="loading" v-if="size === 'small'" data-width="16">
        <svg width='16px' height='16px' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='8' cy='8' r='6' stroke='rgba(255,255,255,0.5)' fill='none' stroke-width='3'>
          </circle>
          <circle cx='8' cy='8' r='6' stroke-dasharray='20 32' stroke-dashoffset='32' stroke='#fff' fill='none' stroke-width='3'></circle>
        </svg>
      </div>
      <div class="loading" v-else-if="size === 'middle'" data-width="50">
        <svg width='50px' height='50px' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='25' cy='25' r='20' stroke='rgba(255,255,255,0.5)' fill='none' stroke-width='3'>
          </circle>
          <circle cx='25' cy='25' r='20' stroke-dasharray='80 100' stroke-dashoffset='100' stroke='#fff' fill='none' stroke-width='3'></circle>
        </svg>
      </div>
      <div class="loading" v-else data-width="150">
        <svg width='150px' height='150px' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='75' cy='75' r='60' stroke='rgba(255,255,255,0.5)' fill='none' stroke-width='3'>
          </circle>
          <circle cx='75' cy='75' r='60' stroke-dasharray='80 600' stroke-dashoffset='600' stroke='#fff' fill='none' stroke-width='3'></circle>
        </svg>
      </div>
      <div class="loading_text" :class="size">{{loadingText}}</div>
    </div>
    <div class="loading_content" v-if="!isWhite">
      <div class="loading" v-if="size === 'small'" data-width="16">
        <svg width='16px' height='16px' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='8' cy='8' r='6' stroke='rgba(0,0,0,0.5)' fill='none' stroke-width='3'>
          </circle>
          <circle cx='8' cy='8' r='6' stroke-dasharray='20 32' stroke-dashoffset='32' stroke='#000' fill='none' stroke-width='3'></circle>
        </svg>
      </div>
      <div class="loading" v-else-if="size === 'middle'" data-width="50">
        <svg width='50px' height='50px' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='25' cy='25' r='20' stroke='rgba(0,0,0,0.5)' fill='none' stroke-width='3'>
          </circle>
          <circle cx='25' cy='25' r='20' stroke-dasharray='80 100' stroke-dashoffset='100' stroke='#000' fill='none' stroke-width='3'></circle>
        </svg>
      </div>
      <div class="loading" v-else data-width="150">
        <svg width='150px' height='150px' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='75' cy='75' r='60' stroke='rgba(0,0,0,0.5)' fill='none' stroke-width='3'>
          </circle>
          <circle cx='75' cy='75' r='60' stroke-dasharray='80 600' stroke-dashoffset='600' stroke='#000' fill='none' stroke-width='3'></circle>
        </svg>
      </div>
      <div class="loading_text" :class="size">{{loadingText}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'loading',
  props: {
    mask: Boolean,
    size: String,
    isWhite: Boolean
  },
  computed: {
    ...mapState({
      loadingType: state => state.app.loadingType
    }),
    loadingText () {
      let result = this.$t('loading')
      if (this.loadingType !== '') {
        let str = ''
        if (this.loadingType === 'logout') {
          str = 'header.' + this.loadingType
        } else {
          str = 'header.' + this.loadingType + 'Load'
        }
        result = this.$t(str)
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.loading_bg {
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  @keyframes rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg) }
  }
  .loading_content {
    height: inherit;
    .loading{
      svg {
        position: absolute;
        animation-name: rotate;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
      &[data-width='16'] {
        svg {
          left: calc(50% - 8px);
          top: calc(50% - 13px);
        }
      }
      &[data-width='50'] {
        svg {
          left: calc(50% - 25px);
          top: calc(50% - 30px);
        }
      }
      &[data-width='150'] {
        svg {
          left: calc(50% - 75px);
          top: calc(50% - 80px);
        }
      }
    }
    &.white {
      color: white;
    }
  }
  .loading_text {
    position: relative;
    text-align: center;
    &.small {
      top: calc(50% - 13px);
    }
    &.middle {
      top: calc(50% + 25px);
    }
    &.big {
      top: calc(50% + 75px);
    }
  }
}
.no_bg {
  @keyframes rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg) }
  }
  .loading_content {
    height: inherit;
    .loading{
      svg {
        position: absolute;
        animation-name: rotate;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
    }
    &.white {
      color: white;
    }
  }
  .loading_text {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/Loading.vue